import React from 'react';
import FinanciarFunctions from './FinanciarFunctions';
import Chart from 'react-apexcharts'


export default class ChartPrognoza extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            series: [



              

                


                {
                    name: 'Prognoza ' + this.props.prognozat.an,
                    type:'column',
                    data:[0,this.f.calculPrognoza(this.props.bilanturi)],
               

                },
                {
                    name: 'Planificare ' + this.props.prognozat.an,
                    type:'column',
                    data: [0, Number(this.props.prognozat.valoare)],
                 

                },

                {
                    name: 'Venituri',
                    type:'line',
                    data:  this.props.bilanturi.map((b)=>{
                        return this.f.getTotalVenituriBilant(b)
                    })
                 },
               
            ],

            options: {

                chart: {
                    height: 350,
                    width: '90%',
                    // type: 'line',
                    events: {
                        click: function (chart, w, e) {
                            // console.log(chart, w, e)
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                colors: ['#4c9eeb', '#eb4b4c', '#ebbe4a',],

                dataLabels: {
                    enabled: false,
                    formatter: function (val, { seriesIndex, dataPointIndex, w }) {
                        console.log('idx :>> ', seriesIndex);
                        console.log('dataPointIndex :>> ', dataPointIndex);
                        console.log('w :>> ', w);
                        console.log('val :>> ', val);
                        return props.bilanturi[dataPointIndex]['an']

                    },
                    offsetY: 20,
                    style: {
                        colors: ['#333']
                    }
                },

                stroke: {
                    width: [0,0,5],
                    curve: 'straight',
                    dashArray: [0]
                },
                legend: {
                    show: true,

                },
                xaxis: {
                    categories: this.props.bilanturi.map((b)=>{
                        return b.an
                    }),




                    // ['Solduri Clienti'],
                    // [
                    //   ['John', 'Doe'],
                    //   ['Joe', 'Smith'],
                    //   ['Jake', 'Williams'],
                    //   'Amber',
                    //   ['Peter', 'Brown'],
                    //   ['Mary', 'Evans'],
                    //   ['David', 'Wilson'],
                    //   ['Lily', 'Roberts'], 
                    // ],
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                },


                // opposite:true
            },

        }
    }

    componentDidMount() {
       
    }


    f = new FinanciarFunctions()
    render() {
        return (
            <div style={{ background: 'white' }} id="chart">


                <Chart
                    style={{ margin: 'auto' }}
                    options={this.state.options}
                    series={this.state.series}
                    // type="line"
                    width="90%"
                    height={400}
                />


            </div>
        );
    }
}